module.exports = __webpack_public_path__ + "static/media/DashBoardFilterIcon.d5152cad.svg";